import React, { Component } from 'react';

import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';

import { Box, FormControl, FormHelperText,TextField } from '@mui/material';
import { startOfDay,endOfDay } from 'date-fns';


 
class DatePickerCustom extends Component {

    render(){
        const { label, value, minDate, maxDate, error, required, noPadding, disabled } = this.props;

    // Utiliser une valeur par défaut pour value
    const defaultValue = value;
    
    return (
      <Box p={noPadding ? 0 : 1}>
        <FormControl variant="outlined" error={!!error} style={{ width: "100%" }}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              label={`${label}${required ? " *" : ""}`}
              value={defaultValue}
              onChange={this.props.onChange || this.props.handleChange}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  error={!!error}
                  helperText={error}
                  InputLabelProps={{ shrink: true }}
                />
              )}
              minDate={minDate}
              maxDate={maxDate}
              disabled={disabled}
              inputFormat="dd/MM/yyyy"
              shouldDisableDate={(date) => date < startOfDay(minDate) || date > endOfDay(maxDate)}
            />
          </LocalizationProvider>
          <FormHelperText>{error}</FormHelperText>
        </FormControl>
      </Box>
    );
    }  
}

export default DatePickerCustom;